






	import AbpBase from "@/lib/abpbase";
    import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
	import {GetExceptionSetting,InsertExceptionSetting} from '../../../api/abnormal'

	@Component({})
	export default class  extends AbpBase {
		list = []

		created(){
			this.getData()
		}
		async getData(){
			let res = await GetExceptionSetting({})
			console.log(res)
			this.list = res;
		}
		async handleSave(row:any){
			let data = {
				itemCode:row.itemCode,
				itemValue:row.itemValue,
				id:row.id,
			}
			let res = await InsertExceptionSetting([data])
			if(res.status == 1){
				this.getData()
				this.$set(row, '$isEdit', false)
			}
        }
        handleEdit(row:any){
            this.$set(row, '$isEdit', true)
        }
		columns = [
			{
				title:'参数描述',
				key:'',
				render:(h:any,p:any)=>{
					switch(p.row.itemCode){
						case 1:
							return h('span','透析血压异常值')
							break;
						case 2:
							return h('span','透析中收缩压异常值')
							break;
						case 3:
							return h('span','体重异常')
							break;
					}
				}
			},
			{
				title:'参数值',
				key:'',
				render: (h:any, params:any) => {
					if (params.row.$isEdit) {
						return h('InputNumber', {
							props: {
								value: params.row.itemValue
							},
							style:{
								width:'200px'
							},
							on: {
								input: function (value:any) {
									params.row.itemValue = value
								}
							}
						});
					} else  {
						return h('div', params.row.itemValue);
					}
				}
			},
			{
				title:'操作',
				key:'',
				width:80,
				render :(h:any,params:any) => {
                    return h('div',[
                        h('Button',{
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style:{
                                marginRight:'15px'
                            },
                            on: {
                                click: () => {
                                    if (params.row.$isEdit) {
										this.handleSave(params.row)
									} else {
										this.handleEdit(params.row)
									}
                                }
                            }
                        }, params.row.$isEdit ? '保存' : '修改'),
                    ])
                },
			}
		]

	}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/abnormal/abnormalSetting/index.vue